import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  ${(props) =>
    props.aspectRatio
      ? `
        aspect-ratio: ${props.aspectRatio};
    `
      : `
        padding-top: 48.65%;
    `}
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.position || 'start'};

  margin-bottom: 50px;
  iframe {
    width: ${(props) => props.iframeWidth};
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`

const Iframe = ({
  src,
  title,
  aspectRatio = 0,
  width = '100',
  position = 'start'
}) => {
  // Get the proper multiplier
  const multiplier = width ? parseInt(width) / 100 : 1
  // Get iframe width in percentage
  const iframeWidth = width ? `${width}%` : '100%'
  // Adjust the aspect ratio for the iframe width
  const adjustedAspectRatio = aspectRatio / multiplier

  return (
    <Wrapper
      iframeWidth={iframeWidth}
      aspectRatio={adjustedAspectRatio}
      position={position}
    >
      <iframe
        src={src}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </Wrapper>
  )
}

export default Iframe
